<script setup lang="ts">
import DatePicker from '@/components/DatePicker.vue'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'
import { beautifyObjectName } from './utils'

const props = defineProps<FieldProps>()
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <slot v-bind="slotProps">
          <DatePicker
            :disabled="props.disabled"
            v-bind="props.config?.inputProps"
            :value="slotProps.componentField.modelValue"
            :label="slotProps.componentField.modelValue"
            @update:value="slotProps.componentField['onUpdate:modelValue']"
          />
        </slot>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
